<div class="sd-dialog">
  <div class="sd-header">
    <div class="sd-title-wrap">
      <div class="sd-title-icon">
        <mat-icon>checklist</mat-icon>
      </div>
      <div>
        <h2 class="sd-title">Subtasks</h2>
        <div class="sd-subtitle">Break this task into smaller steps</div>
      </div>
    </div>
    <button type="button" mat-icon-button class="sd-close" (click)="close()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="sd-body">
    @if (subtasks.length === 0) {
      <div class="sd-empty">
        <div class="sd-empty-icon">
          <mat-icon>playlist_add</mat-icon>
        </div>
        <h3>No subtasks yet</h3>
        <p>Add the first step needed to complete this task.</p>
        <button type="button" class="sd-add-primary" (click)="add()">
          <mat-icon>add</mat-icon>
          Add first subtask
        </button>
      </div>
    } @else {
      <div class="sd-toolbar">
        <span>Drag to reorder</span>
        <button type="button" class="sd-add-link" (click)="add()">
          <mat-icon>add</mat-icon>
          Add subtask
        </button>
      </div>

      <div cdkDropList class="sd-list" (cdkDropListDropped)="drop($event)">
        @for (subtask of subtasks; track subtask; let i = $index) {
          <div class="sd-row" [class.sd-row-expanded]="subtask.displayDescription" cdkDrag>
            <div class="sd-placeholder" *cdkDragPlaceholder></div>
            <div class="sd-row-main">
              <button type="button" class="sd-handle" cdkDragHandle aria-label="Drag to reorder subtask">
                <mat-icon>drag_indicator</mat-icon>
              </button>
              <span class="sd-index">{{i + 1}}</span>
              <input #subtaskTitle class="sd-title-input" type="text" placeholder="Describe this subtask"
                [(ngModel)]="subtask.subtask.title" (keydown.enter)="addFromKeyboard($event, i)"
                [attr.aria-label]="'Subtask ' + (i + 1) + ' title'">
              <button type="button" class="sd-icon-btn" [class.on]="subtask.displayDescription"
                (click)="more(subtask)" [attr.aria-expanded]="subtask.displayDescription"
                [attr.aria-label]="subtask.displayDescription ? 'Hide description' : 'Add or edit description'">
                <mat-icon>notes</mat-icon>
                @if (subtask.subtask.description) {
                  <span class="sd-status-dot"></span>
                }
              </button>
              <button type="button" class="sd-icon-btn sd-delete" (click)="remove(i)" aria-label="Delete subtask">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </div>

            @if (subtask.displayDescription) {
              <div class="sd-description">
                <label [for]="'subtask-description-' + i">Description <span>· optional</span></label>
                <textarea [id]="'subtask-description-' + i" rows="3" placeholder="Add helpful details or instructions"
                  [(ngModel)]="subtask.subtask.description"></textarea>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="sd-footer">
    <span class="sd-count">
      <mat-icon>format_list_numbered</mat-icon>
      {{subtasks.length}} subtask{{subtasks.length === 1 ? '' : 's'}}
    </span>
    <div class="sd-footer-actions">
      <button type="button" mat-button class="sd-btn-ghost" (click)="close()">Cancel</button>
      <button type="button" class="sd-btn-primary" (click)="save()">
        <span>Save subtasks</span>
        <mat-icon>check</mat-icon>
      </button>
    </div>
  </div>
</div>
